import { jsx as o, Fragment as c } from "react/jsx-runtime";
import a from "react";
const s = ({
  children: r,
  maxChildren: e,
  componentName: n,
  additionalInfo: t
}) => /* @__PURE__ */ o(c, { children: (() => {
  if (a.Children.count(r) > e)
    throw new Error(
      `${n} component can have a maximum of ${e} children. ${t}`
    );
})() });
export {
  s as C
};
